import React, { useEffect, useState } from "react";
import { IoMdMenu } from "react-icons/io";
import MenuBar from "../Menubar/MenuBar";
export default function HeaderMobile({ setIsMenuBarOpen }) {
  const [headerBgColor, setHeaderBgColor] = useState("transparent");
  useEffect(() => {
    if (window.location.pathname === "/") {
      setHeaderBgColor("#FFF");
    } else {
    }
    window.addEventListener("scroll", () => {
      if (window.scrollY > 50) {
        setHeaderBgColor("#FFFFFF");
      } else {
        setHeaderBgColor("");
      }
    });
  }, []);
  return (
    <div
      style={{ backgroundColor: `${headerBgColor}` }}
      className="fixed min-[769px]:hidden w-full  h-[60px]  left-1/2 -translate-x-1/2  flex flex-col items-center justify-center px-[20px] z-30 "
    >
      <div className="w-full flex items-center justify-between ">
        <div className="w-[120px]  flex  items-center justify-start shrink-0 ">
          <a href="/">
            <img
              src="/../assets/images/mainPage/img_logoTextEn.png"
              className="w-[100px] h-[20px] cursor-pointer"
            />
          </a>
        </div>
        <div className="w-[120px]  flex  items-center justify-end shrink-0 text-[24px] text-color-primary-F">
          <span
            onClick={() => {
              setIsMenuBarOpen("true");
            }}
          >
            <IoMdMenu />
          </span>
        </div>
      </div>
    </div>
  );
}
